import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export const getPhoneValidationError = (value) => {
  const trimmed = String(value || '').trim();
  if (!trimmed) {
    return 'El teléfono celular es requerido';
  }

  const parsed = parsePhoneNumberFromString(trimmed, 'AR')
    ?? parsePhoneNumberFromString(trimmed);

  if (!parsed?.isValid()) {
    return 'El número de teléfono no es válido';
  }

  return '';
};

export const getEmailValidationError = (value, { required = true } = {}) => {
  const trimmed = String(value || '').trim();
  if (!trimmed) {
    return required ? 'El email es requerido' : '';
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
    return 'Por favor, ingresa un email válido';
  }

  return '';
};

export const isValidPhoneValue = (value) => getPhoneValidationError(value) === '';

export const isValidEmailValue = (value, options) => getEmailValidationError(value, options) === '';
